import {APP_PREFIX_PATH} from "../AppConfig";
import React from "react";

export const courriers = [
    {
        key: "my-affects",
        path: `${APP_PREFIX_PATH}/mes-affectations`,
        component: React.lazy(() => import("views/app-views/courrier/myAffects")),
        meta: {
            permission: "MES_AFFECTATIONS"
        }
    },

    {
        key: "pending-courriers",
        path: `${APP_PREFIX_PATH}/pending-courriers`,
        component: React.lazy(() => import("views/app-views/courrier/pendingCourriers")),
        meta: {
            permission: "MES_AFFECTATIONS"
        }
    },

    {
        key: "my-records",
        path: `${APP_PREFIX_PATH}/mes-enregistrements`,
        component: React.lazy(() => import("views/app-views/courrier/myRecords")),
        meta: {
            permission: "MES_ENREGISTREMENTS"
        }
    },

    {
        key: "courriers",
        path: `${APP_PREFIX_PATH}/courriers/:type`,
        component: React.lazy(() => import("views/app-views/courrier/courriers")),
    },

    {
        key: "courrier-create",
        path: `${APP_PREFIX_PATH}/courrier/:type/:nature`,
        component: React.lazy(() => import("views/app-views/courrier/type")),
    },
     {
        key: "courrier-remove",
        path: `${APP_PREFIX_PATH}/courrier/:type/remove`,
        component: React.lazy(() => import("views/app-views/retraitDossier/add")),
    },
    {
        key: "courrier-show",
        path: `${APP_PREFIX_PATH}/courrier/:code/show`,
        component: React.lazy(() => import("views/app-views/courrier/show")),
        meta: {
            permission: "VIEW_COURRIER"
        }
    },
    {
        key: "courrier-remove",
        path: `${APP_PREFIX_PATH}/retraitDossier/:code/add`,
        component: React.lazy(() => import("views/app-views/retraitDossier/add")),
        meta: {
            permission: "WITHDRAW_DOSSIER"
        }
    },
     {
        key: "courrier-resultat",
        path: `${APP_PREFIX_PATH}/resultatDossier/:courrierCode`,
        component: React.lazy(() => import("views/app-views/resultatDossier/add")),
        meta: {
            permission: "RESULT_DOSSIER"
        }
    },

    {
        key: "courrier-edit",
        path: `${APP_PREFIX_PATH}/courrier/:code/edit`,
        component: React.lazy(() => import("views/app-views/courrier/edit")),
        meta: {
            permission: "UPDATE_COURRIER"
        }
    },

    {
        key: "regularisation-dossier",
        path: `${APP_PREFIX_PATH}/courrier/regularisation-dossier`,
        component: React.lazy(() => import("views/app-views/courrier/regularisationDossier"))
    },

    {
        key: "regularisation-dossier/update",
        path: `${APP_PREFIX_PATH}/courrier/regularisation-dossier/attributaires`,
        component: React.lazy(() => import("views/app-views/courrier/regularisationDossierAttributaire"))
    },

    {
        key: "regularisation-dossier/attributaires",
        path: `${APP_PREFIX_PATH}/courrier/regularisation-dossier/update`,
        component: React.lazy(() => import("views/app-views/courrier/regularisationDossierUpdate"))
    },

    {
        key: "enregistrement-dossier",
        path: `${APP_PREFIX_PATH}/courrier/waiting-affectation`,
        component: React.lazy(() => import("views/app-views/courrier/waitingAffectation"))
    },

    {
        key: "dossiers-a-signer",
        path: `${APP_PREFIX_PATH}/dossiers-a-signer`,
        component: React.lazy(() => import("views/app-views/courrier/dossiersASigner")),
        meta: {permission: "LIST_DOSSIER_A_SIGNER"}
    },
    {
        key: "dossiers-signes",
        path: `${APP_PREFIX_PATH}/dossiers-signes`,
        component: React.lazy(() => import("views/app-views/courrier/dossiersSignes")),
        meta: {permission: "LIST_DOSSIER_SIGNES"}
    },
]